import { useState } from 'react';
import type { EventClickArg } from '@fullcalendar/core';
import { FullCalendarEvent } from '../hooks/useReservableCalendarView';
import { isFullCalendarEvent } from '../Calendar/CalendarViews';
import { getEventsForDay } from './mapReservablesToMonthEvents';

type DayModalState = {
  date: Date;
  events: FullCalendarEvent[];
  anchorRect: DOMRect;
} | null;

export function useCalendarModals(
  filteredEvents: FullCalendarEvent[],
  channelTimeZone: string
) {
  const [selectedEvent, setSelectedEvent] = useState<FullCalendarEvent | null>(
    null
  );
  const [dayModal, setDayModal] = useState<DayModalState>(null);

  const handleEventClick = (arg: EventClickArg) => {
    if (isFullCalendarEvent(arg.event)) {
      setSelectedEvent(arg.event);
    }
  };

  const handleMoreLinkClick = (date: Date, anchorRect: DOMRect) => {
    setDayModal({
      date,
      events: getEventsForDay(filteredEvents, date, channelTimeZone),
      anchorRect,
    });
  };

  const closeDayModal = () => setDayModal(null);
  const closeSelectedEvent = () => setSelectedEvent(null);
  const selectEventFromDay = (event: FullCalendarEvent) => {
    setDayModal(null);
    setSelectedEvent(event);
  };

  return {
    selectedEvent,
    dayModal,
    handleEventClick,
    handleMoreLinkClick,
    closeDayModal,
    closeSelectedEvent,
    selectEventFromDay,
  };
}
